import React, { useState, useEffect, useMemo } from 'react';
import { TeamOutlined, SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import PageHeading from '../../components/PageHeading';
import {
  Button,
  Table,
  Input,
  Popconfirm,
  message,
} from 'antd';
import PartnerModal from './PartnerModal';
import axiosInstance from '../../utils/axios';
import { dateFormat } from '../../utils/dateFormats';

const Partner = () => {
  const [partners, setPartner] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("core/partner/");
      setPartner(response.data);
    } catch (error) {
      message.error("Failed to fetch partners");
    } finally {
      setLoading(false);
    }
  };

  const confirm = async (id) => {
    try {
      await axiosInstance.delete(`core/partner/${id}/`);
      message.success("Deleted successfully");
      setPartner(prev => prev.filter(partner => partner.id !== id));
    } catch (err) {
      message.error("Cannot delete");
    }
  };

  const cancel = () => message.info('Cancelled');

  const openModalUpdate = (id) => {
    setSelectedId(id);
    setCreateModalOpen(true);
  };

  const openModalCreate = () => {
    setSelectedId(null);
    setCreateModalOpen(true);
  };

  const filteredPartners = useMemo(() => {
    if (partners) 
      return partners.filter(partner =>
        partner.name.toLowerCase().includes(search.toLowerCase())
      );
  }, [search, partners]);

  const columns = [
    {
      title: 'Logo',
      dataIndex: 'logo',
      key: 'logo',
      render: (_, record) => record.restricted ? null : (
        <img src={record.logo} width={50} height={40} alt="Logo" />
      )
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Created at',
      dataIndex: 'created_at',
      key: 'created_at',
      render: text => dateFormat(text),
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'actions',
      render: (_, record) => record.restricted ? null : (
        <>
          <Button type="link" icon={<EditOutlined />} onClick={() => openModalUpdate(record.id)} />
          <Popconfirm
            title="Delete"
            description="Are you sure to delete this item?"
            onConfirm={() => confirm(record.id)}
            onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </>
      )
    },
  ];

  return (
    <div className='dashboard'>
      <PageHeading name="Partners" icon={<TeamOutlined />} />

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 16
      }}>
        <Input
          placeholder="Search here"
          prefix={<SearchOutlined />}
          style={{ width: "190px" }}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Button type="primary" onClick={openModalCreate}>Add new</Button>
      </div>

      <Table
        dataSource={filteredPartners}
        loading={loading}
        columns={columns}
        rowKey="id"
        pagination
        
      />

      <PartnerModal
        open={createModalOpen}
        setOpen={setCreateModalOpen}
        partners={partners}
        setPartner={setPartner}
        selectedId={selectedId}
      />
    </div>
  );
};

export default Partner;
